export interface PortfolioSlot {
  id: string
  category: string
  name: string
  image: string
}

// Live client screenshots. To add another site: append a slot with its category,
// business name, and the uploaded screenshot URL.
export const portfolioSlots: PortfolioSlot[] = [
  {
    id: 'home-services',
    category: 'Home Services',
    name: 'A-Flow Seamless Rain Gutters',
    image: 'https://cdn.magicpatterns.com/uploads/7MeFjSz2zYjyPV8yxHNLS7/AFlow.png',
  },
  {
    id: 'real-estate',
    category: 'Real Estate',
    name: 'Cabo Collection',
    image: 'https://cdn.magicpatterns.com/uploads/dAfDw4Jrn1XmDgNyXmq164/CaboCasa.png',
  },
  {
    id: 'restaurant',
    category: 'Restaurant',
    name: 'Pizza Warehouse',
    image: 'https://cdn.magicpatterns.com/uploads/nSXb3nCe4126DrrwvswMTs/PizzaWarehouse.png',
  },
  {
    id: 'logistics',
    category: 'Logistics',
    name: 'LynJones Logistics',
    image: 'https://cdn.magicpatterns.com/uploads/qtTZBEnz6aPiAyGDNhxgYS/LynJones_Boats.png',
  },
  {
    id: 'healthcare',
    category: 'Healthcare',
    name: 'Arissa Cost Solutions',
    image: 'https://cdn.magicpatterns.com/uploads/9X8H6g37AqrqhJ1dQQkMea/ArissaCS.png',
  },
  {
    id: 'roofing-exterior',
    category: 'Roofing/Exterior',
    name: 'Moceri Residential Services',
    image: 'https://cdn.magicpatterns.com/uploads/iPLzNnfGWJnfPEABPaNyan/MoceriRS.png',
  },
  {
    id: 'marketing-agency',
    category: 'Marketing Agency',
    name: 'Ad ROI Marketing',
    image: 'https://cdn.magicpatterns.com/uploads/3PJg2pQCYJMvtkrWWAmvTo/adroi-marketing.png',
  },
  {
    id: 'real-estate-2',
    category: 'Real Estate',
    name: 'Cabo Deal Flow',
    image: 'https://cdn.magicpatterns.com/uploads/3HMyjF1eekuRuHKcqc2qxz/CaboDealFlow.png',
  },
  {
    id: 'plumbing',
    category: 'Plumbing',
    name: 'Done Right Plumbing',
    image: 'https://cdn.magicpatterns.com/uploads/qtzMzLkAcKpLAn6ZULJ6U6/DoneRightPlumbing.png',
  },
  {
    id: 'exterior-cleaning',
    category: 'Exterior Cleaning',
    name: 'SoftWash Pros',
    image: 'https://cdn.magicpatterns.com/uploads/sdw9MqWvMEByucaNx4ZSda/SoftWashPros.png',
  },
  {
    id: 'med-spa',
    category: 'Med Spa & Esthetics',
    name: 'Parkway Esthetics',
    image: 'https://cdn.magicpatterns.com/uploads/k2i9nypxhn8RM59kEN39gK/ParkwayEsthetics.png',
  },
  {
    id: 'restaurant-2',
    category: 'Restaurant',
    name: 'Slice Heaven',
    image: 'https://cdn.magicpatterns.com/uploads/1rzdyCiwCGyqVr3L4eJ6Va/SliceofHeaven.png',
  },
]
